import { useTranslation } from 'next-i18next';
import WhatIfLogo from 'public/images/what-if-icon.svg';
import React, { FC } from 'react';

import { Search } from '@/components/search/Search';

import * as S from './SearchSection.styles';

export const SearchSection: FC = () => {
  const { t } = useTranslation('common');

  return (
    <S.Container data-testid="home-page">
      <S.LogoContainer>
        <WhatIfLogo alt={t('whatIfAlt')} />
        <S.Title>
          <span>
            {t('whatIf')}
            <mark>&#8480;</mark>
          </span>
          <S.Subtitle>{t('earnings')}</S.Subtitle>
        </S.Title>
      </S.LogoContainer>
      <Search />
    </S.Container>
  );
};
